import React from "react"
import Announcement from "./Announcement"
import IJSTitle from "./assets/Title.png"

function Nav() {
  return (
    <div className="fixed top-0 z-50 w-full">
      <header className="bg-white max-lg:hidden">
        <div className="mx-auto flex h-16 max-w-screen-xl items-center gap-8 px-4 sm:px-6 lg:px-8">
          <a className="block text-teal-600" href="#">
            <span className="sr-only">Home</span>
            <img src={IJSTitle} alt="IJS PNG" className="h-8 w-auto" />
          </a>

          <div className="flex flex-1 items-center justify-center md:justify-end">
            <nav aria-label="Global" className="hidden md:block">
              <ul className="flex items-center gap-6 text-sm">
                <li>
                  <a
                    className="text-gray-500 transition hover:text-gray-500/75"
                    href="#"
                  >
                    {" "}
                    Home{" "}
                  </a>
                </li>

                <li>
                  <a
                    className="text-gray-500 transition hover:text-gray-500/75"
                    href="#about"
                  >
                    {" "}
                    About{" "}
                  </a>
                </li>

                <li>
                  <a
                    className="text-gray-500 transition hover:text-gray-500/75"
                    href="#services"
                  >
                    {" "}
                    Services{" "}
                  </a>
                </li>

                <li>
                  <a
                    className="text-gray-500 transition hover:text-gray-500/75"
                    href="#faq"
                  >
                    {" "}
                    Questions{" "}
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div>
          {/* <Announcement
            color="red"
            underlined_text="STORE CLOSED:"
            text="IJS Ink and Toner will be indefinitely closed. We apologize for any inconvenience this may cause."
          /> */}
          <Announcement
            color="blue"
            underlined_text="NOTICE:"
            text={<span>If you need our services or have any other inquiries, please send an email to <a href="mailto:annieijs94@gmail.com" className="underline">annieijs94@gmail.com</a>.</span>}
          />
        </div>
      </header>
    </div>
  )
}

export default Nav
